// extracted by mini-css-extract-plugin
export default {"send":"styles_send__sCZFC","cancel":"styles_cancel__0khJe"};